import * as Location from 'expo-location';

import { fromPromise } from 'xstate';

import type { RequestBackgroundLocationPermissionOutput } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const requestBackgroundLocationPermissionActor =
  fromPromise<RequestBackgroundLocationPermissionOutput>(async () =>
    Location.requestBackgroundPermissionsAsync(),
  );
